import type {
  ErrorModalProps,
  ConfirmationModalProps,
  SuccessModalProps,
} from '@/components/modals';

export enum ModalType {
  ErrorModal = 'ErrorModal',
  ConfirmationModal = 'ConfirmationModal',
  SuccessModal = 'SuccessModal',
  OpenAppModal = 'OpenAppModal',
}

type ModalsPropsMap = {
  [ModalType.ErrorModal]: ErrorModalProps;
  [ModalType.ConfirmationModal]: ConfirmationModalProps;
  [ModalType.SuccessModal]: SuccessModalProps;
  [ModalType.OpenAppModal]: void;
};

export type ModalProps<T> = T extends ModalType ? ModalsPropsMap[T] : never;

export interface Modal {
  type: ModalType;
  componentProps: ModalProps<ModalType>;
}
